export const parseLegacyBp = (bp) => {
  if (!bp) return { systolic: "", diastolic: "" };
  const parts = bp.split("/").map((s) => s.trim());
  if (parts.length !== 2) return { systolic: "", diastolic: "" };
  return { systolic: parts[0], diastolic: parts[1] };
};
